import React, { useEffect, useState } from "react";
import { Building2, Globe, Users, Phone, Mail, MapPin } from 'lucide-react';
import { Box, Grid, Typography, IconButton, Chip, Divider ,Dialog,DialogContent} from '@mui/material';
import { userSelector } from "../../../user-redux/selector";
import { appSelector } from "../../../redux/selector";
import { useSelector, useDispatch } from "react-redux";
import { Edit } from '@mui/icons-material'; // Edit icon
import Candidateprofile from "../../Candidateprofile";
import Recruterprofile from "../../Recruiterprofile";
import AdminProfilesettings from "../../Adminprofilesettings";
import { getCountriesAction, getStatesAction, getCitiesAction } from "../../../redux/action";

const CompanyDetails = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(userSelector);
    const { countriesList, statesList, citiesList } = useSelector(appSelector);
    const [activeStep, setActiveStep] = useState(0);
    // Load location data on component mount
    useEffect(() => {
        if (!countriesList || countriesList.length === 0) {
            dispatch(getCountriesAction());
        }
        if (user?.company_country && (!statesList || statesList.length === 0)) {
            dispatch(getStatesAction(user.company_country));
        }
        if (user?.company_state && (!citiesList || citiesList.length === 0)) {
            dispatch(getCitiesAction(user.company_state));
        }
    }, [user?.company_country, user?.company_state, dispatch, countriesList, statesList, citiesList]);
    // Helper function to get name by ID from a list
    const getNameById = (id, list) => {
        if (!id || !list || list.length === 0) return null;
        const item = list.find(item => item.id === parseInt(id));
        return item ? item.name : null;
    };
    const companyInfo = [
        { icon: Building2, label: 'Company Name', value: user.company_name || 'N/A' },
        { icon: Globe, label: 'Website', value: user.url || 'N/A' },
        { icon: Users, label: 'Industry', value: user.department || 'IT Software' },
        { icon: Phone, label: 'Phone', value: user.contactphone || 'N/A' },
        { icon: Mail, label: 'Email', value: user.username || 'N/A' },
        {
            icon: MapPin,
            label: 'Location',
            value: user.company_address1 || (() => {
                console.log('=== Address Concatenation Logic ===');
                // Convert IDs to names using Redux data
                const cityName = getNameById(user.company_city, citiesList);
                const stateName = getNameById(user.company_state, statesList);
                const countryName = getNameById(user.company_country, countriesList);
                const zipcode = user.company_zipcode || user.zipcode;
                const addressParts = [
                    cityName,
                    stateName,
                    countryName,
                    zipcode
                ].filter(part => part && String(part).trim() !== '');
                const result = addressParts.length > 0 ? addressParts.join(', ') : 'N/A';
                return result;
            })()
        },
    ];
    const [isEditClicked, setIsEditClicked] = useState(false);

    const [showCompanySettings, setShowCompanySettings] = useState(false); // State for password settings



    // Render the content dynamically based on the usertype
    const renderDialogContent = () => {
        if (user?.usertype == 7 || user?.usertype == 13) {
            return <AdminProfilesettings showCompanySettings={2} setIsEditClicked={setIsEditClicked} />;
        } else {
            return <p>No Settings Available for this User Type</p>;
        }
    };

    const handleEditClick = () => {
        setIsEditClicked((prev) => !prev); // Toggle the state
    };

     useEffect(() => {
         console.log('showCompanySettings', showCompanySettings);
         if (showCompanySettings) {
                setActiveStep(1); // Set activeStep to 1 when showPasswordSettings is true
            }
     }, [showCompanySettings]);
        

    return (
        <Box
            sx={{
                bgcolor: 'background.paper',
                borderRadius: 3,
                boxShadow: 2,
                p: 3,
                maxWidth: 1200,
                margin: '0',
            }}
        >
            {/* Header Section */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <IconButton
                        sx={{
                            bgcolor: '#e3f2fd',
                            color: '#1e88e5',
                            width: 56,
                            borderRadius: 1.5,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Building2 size={28} />
                    </IconButton>
                    <Typography variant="h5" fontWeight="bold" color="text.primary">
                        Company Details
                    </Typography>
                </Box>

                {/* Edit Icon and Active Chip */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {user?.usertype == 7 && (
                        <IconButton onClick={handleEditClick}
                            size="small"
                            sx={{
                                color: '#1e88e5',
                                borderRadius: 1,
                            }}
                        >
                            <Edit size={20} />
                        </IconButton>
                    )}
                    <Chip
                        label="Active"
                        color="success"
                        size="small"
                        sx={{
                            fontWeight: 'medium',
                            textTransform: 'uppercase',
                            borderRadius: 1,
                            letterSpacing: 1,
                        }}
                    />
                </Box>
            </Box>

            {/* Info Section - Side by Side */}
            <Grid container spacing={3}>
                {companyInfo.map((info, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        {/* Divider line between items */}
                        {index !== 0 && <Divider sx={{ my: 1 }} />}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between', // Align items between left and right
                                gap: 2,
                            }}
                        >
                            {/* Left side: Icon and Label/Value */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
                                <IconButton
                                    size="small"
                                    sx={{
                                        bgcolor: '#e3f2fd',
                                        color: '#1e88e5',
                                        width: 40,
                                        height: 40,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <info.icon size={20} />
                                </IconButton>
                                <Box>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        {info.label}
                                    </Typography>
                                    <Typography variant="body1" fontWeight="medium" color="text.primary">
                                        {info.value}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            {isEditClicked && (
                <Box sx={{ marginTop: 4 }}>{renderDialogContent()}</Box>
            )}
             {/* <Dialog
                            open={openDialog}
                            onClose={handleCloseDialog}
                            maxWidth="sm"
                            fullWidth
                        >
                            <DialogContent>{renderDialogContent()}</DialogContent>
                        </Dialog> */}
        </Box>
    );
};

export default CompanyDetails;
